import React, { useEffect, useState } from "react";

import { API } from "../../constants/Api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Modal } from "antd";
import DataTable from "react-data-table-component";

function Payments() {
  const token = localStorage.getItem("token");

  const [data, setData] = useState([]); // Combined data for tours and offers
  const [data2, setData2] = useState([]); // Combined data for tours and offers
  const [selectedData, setSelectedData] = useState([]);
  const [user, setUser] = useState([]);
  const [update, setUpdate] = useState(0);
  const [reason, setReason] = useState("");
  const [openResponsive, setOpenResponsive] = useState(false);
  const [openResponsive2, setOpenResponsive2] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [openReason2, setOpenReason2] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("Advertiser");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Fetch data for tours and offers
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API}/stripe/payment?agentVendorType=${activeTab}`
        );
        const json = await response.json();

        if (response.ok) {
          setData(json.data || []);
          setData2([]);
        }else{
          setData([])
          setData2([])
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    const fetchData2 = async () => {
      try {
        const response = await fetch(`${API}/stripe/advertiser-succeeded`);
        const json = await response.json();

        if (response.ok) {
          const newData =
            (await json.data?.filter((item) => item.advertiser)) || [];

          setData2(newData);
          setData([]);
        }else{
          setData2([]);
          setData([]);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (activeTab === "Advertiser") {
      setLoading(true);
      fetchData2();
    } else {
      setLoading(true);
      fetchData();
    }
    // fetchData2()
    // fetchData()
  }, [update, token, activeTab]);

  // Fetch user details

  // Open modal for selected lead
  const openTerms = (myData) => {
    setSelectedData(myData);
    setOpenResponsive(true);
  };

  // Handle approve/disapprove actions
  const handleApprove = async (tourId, status) => {
    const data = {
      id: tourId,
      accountStatus: status,
    };
    const loading = toast.loading("Processing...");
    try {
      const response = await fetch(
        `${API}/advertiser/advertisers/account-status`,
        {
          method: "PUT",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await response.json();

      if (response.ok) {
        toast.success(json.message);
        setOpenResponsive(false);
        setUpdate(update + 1);
      } else {
        toast.error(json.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      toast.dismiss(loading);
      setReason("");
    }
  };

  // Columns for DataTable
  const columns = [
    {
      name: "Agent Name",
      selector: (row) => row.agent.agentName,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            {row.agent.imageUrl !== null ? (
              <>
                {" "}
                <img
                  src={row.agent.imageUrl !== null ? row.agent.imageUrl : ""}
                  className="table-layout-content-header-image-media img-fluid"
                  alt=""
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.agent.agentName}
            </h3>
            <p className="table-layout-content-header-details-zipcode my-0">
              {row.agent.agentVendorType === "Transaction Coordinator"
                ? "California"
                : ""}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "300px",
    },

    {
      name: "Agent Type",
      selector: (row) => row.agent.agentVendorType,
      sortable: true,
      minWidth: "200px",
      center: true,
    },
    {
      name: "Amount",
      selector: (row) => `$${row.amount}`,

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    {
      name: "Payment Status",
      selector: (row) => row.paymentStatus,
      cell: (row) =>
        row.paymentStatus === "pending" ? (
          <div className="tour-status-pending-1">{row.paymentStatus}</div>
        ) : (
          <div className="tour-status-completed-1">{row.paymentStatus}</div>
        ),

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <button className="tour-cta-1" onClick={() => openTerms(row._id)}>
    //       Expand
    //     </button>
    //   ),
    //   minWidth: "200px",
    // },
  ];
  const columns2 = [
    {
      name: "Advertiser Name",
      selector: (row) => row.advertiser.fulName,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            {row.advertiser.imageUrl !== null ? (
              <>
                {" "}
                <img
                  src={
                    row.advertiser.imageUrl !== null
                      ? row.advertiser.imageUrl
                      : ""
                  }
                  className="table-layout-content-header-image-media img-fluid"
                  alt=""
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.advertiser.fulName}
            </h3>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "200px",
    },

    {
      name: "Type",
      selector: (row) => row.advertiser.titleCompany,
      sortable: true,
      minWidth: "200px",
      center: true,
    },
    {
      name: "Amount",
      selector: (row) => `$${row.amount}`,

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    {
      name: "Payment Status",
      selector: (row) => row.paymentStatus,
      cell: (row) =>
        row.paymentStatus === "pending" ? (
          <div className="tour-status-pending-1">{row.paymentStatus}</div>
        ) : (
          <div className="tour-status-completed-1">{row.paymentStatus}</div>
        ),

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <button
    //       className="tour-cta-1"
    //       onClick={() => openTerms(row.advertiser)}
    //     >
    //       Expand
    //     </button>
    //   ),
    //   minWidth: "200px",
    //   center: true,
    // },
  ];

  // Custom styles for DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };

  return (
    <div className="agent-lead">
      <h2 className="user-layout-page-heading">Payments</h2>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mt-4 px-0">
            <div className="">
              <button
                className={`btn agent-leads-tab ${activeTab === "Advertiser" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Advertiser")}
              >
                Advertisers
              </button>
              <button
                className={`btn agent-leads-tab ${activeTab === "Transaction Coordinator" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Transaction Coordinator")}
              >
                Transaction Coordinators
              </button>
              <button
                className={`btn agent-leads-tab ms-3 ${activeTab === "Showing Agent" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Showing Agent")}
              >
                Showing Agents
              </button>
              <button
                className={`btn agent-leads-tab ms-3 ${activeTab === "Listing Agent" ? "active-agent-leads-tab" : ""}`}
                onClick={() => setActiveTab("Listing Agent")}
              >
                Listing Agents
              </button>
            </div>
          </div>
        </div>
      </div>
      {activeTab === "Advertiser" ? (
        <>
          {loading ? (
            <div className="wait-loader">
              <div className="spinner-grow text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="container-fluid agent-buy-leads-container">
              <Modal
                centered
                open={openResponsive}
                footer={null}
                closable={false}
                width={{
                  xs: "100%",
                  sm: "100%",
                  md: "70%",
                  lg: "50%",
                  xl: "40%",
                  xxl: "40%",
                }}
              >
                <div
                  className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
                >
                  <img
                    src="/img/pop-up-close.svg"
                    className="img-fluid pop-up-close"
                    onClick={() => setOpenResponsive(false)}
                    role="button"
                    alt=""
                  />
                  <div className={`container-fluid ${isMobile ? "px-0" : ""}`}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-12">
                            {selectedData ? (
                              <div className="lending-header-box">
                                <div className="lending-header-image">
                                  {selectedData.imageUrl ? (
                                    <img
                                      src={selectedData.imageUrl}
                                      className="lending-image-media"
                                      alt=""
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="lending-header-details">
                                  <h3
                                    className="lending-header-details-name my-0"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {selectedData.fulName}
                                  </h3>
                                  <span
                                    className="badge rounded-pill ms-3 user-badge"
                                    style={{
                                      backgroundColor: "#1e1e1e!important",
                                    }}
                                  >
                                    {selectedData.accountStatus === "active"
                                      ? "Active"
                                      : "Inactive"}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div className="row mt-5 d-flex justify-content-center">
                          <>
                            <div className="col-md-6">
                              <button
                                onClick={() =>
                                  handleApprove(selectedData._id, "active")
                                }
                                className="btn lead-allow-button"
                              >
                                Active
                              </button>
                            </div>
                            <div className="col-md-6">
                              <button
                                onClick={() =>
                                  handleApprove(selectedData._id, "deactive")
                                }
                                className="btn lead-deny-button"
                              >
                                Deactivate
                              </button>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <div className="row">
                {data2.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns2}
                      data={data2}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={false}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t any data to display.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {loading ? (
            <div className="wait-loader">
              <div className="spinner-grow text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="container-fluid agent-buy-leads-container">
              <div className="row">
                {data.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={false}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t any data to display.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Payments;
